// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import AiStatusController from "./ai_status_controller"
import BrowserChallengeController from "./browser_challenge_controller"
import ChatController from "./chat_controller"
import ChatConnectionController from "./chat_connection_controller"
import RemoteBrowserController from "./remote_browser_controller"
import ThemeController from "./theme_controller"
import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)
application.register("theme", ThemeController)
application.register("chat", ChatController)
application.register("chat-connection", ChatConnectionController)
application.register("remote-browser", RemoteBrowserController)
application.register("ai-status", AiStatusController)
application.register("browser-challenge", BrowserChallengeController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
